module.exports = __webpack_public_path__ + "static/media/03.4d126b5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/03.jpg
// module id = 23
// module chunks = 0